import React from "react";
import { Link } from "react-router-dom";

export default function Side({ display, margin ,click }) {
  return (
    <div className={`col-12 col-lg-1 p-0  ${display}`}>
      <div className={`col-12 h-100 ${margin} `}>
        <div className={`sidebar `}>
          <div className="col-12 py-0 py-lg-3 h-100">
            <ul className="nav side-bar-prof nav-tabs px-0 hed-nav border-0 mt-3 mx-auto d-block">
              <li id="aboutMe" className="px-2 pt-2 mx-auto my-4 text-center "
              
              >
                <Link to="/aboutme">
                  <i className="fa fa-user"></i>
                  درباره من
                </Link>
              </li>
              <li  id="cV" className="px-2 pt-2  mx-auto my-4 text-center">
              <Link to="/CV">
              <i className="fa fa-file"></i>رزومه
              </Link>
              </li>
              <li id="works" className="px-2 pt-2  mx-auto my-4 text-center">
              <Link to="/Works">
              <i className="fa fa-clone"></i>نمونه کار
              </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
